<template>
  <div class="modal" tabindex="-1" role="dialog" id="address-modal" :style="'display: '+displayModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('support.phone.change') }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelEdit">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="payment-form__delivery-address">
            <Phone
              :$v="$v.form.customer_phone"
              :ccform="form"
              ccname="countryCodePhoneField"
              :form="form"
              name="customer_phone"/>
            <br/>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saveForm">Save</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="cancelEdit">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globals from '../mixins/globals';
import * as extraFields from '../mixins/extraFields';
import Phone from './common/common-fields/Phone';
import * as validators from './../validation/validators';

export default {
  name: "ChangeOrderPhone",
  props: {
    order: {
      type: Object,
      required: true
    },
  },
  components: {
    Phone
  },
  mixins: [
    globals,
    extraFields.tplMixin,
  ],
  data() {
    return {
      displayModal: 'none',
      isLoading: {
        address: false,
      },
      form: {
        countryCodePhoneField: null,
        customer_phone: null
      },
    }
  },

  validations: {
    form: {
      customer_phone: validators.getPhoneRules(),
    }
  },

  methods: {

    resetFields() {
      this.form.customer_phone = '';
      this.form.countryCodePhoneField = null;
    },

    async saveForm() {
      this.$v.form.$touch();

      if (this.$v.$invalid) {
        return false;
      }
      this.$emit('submit', this.form);
    },

    setInputFields() {
      this.form.customer_phone = this.order.customer_phone;
      this.form.countryCodePhoneField = this.order.countryCodePhoneField;

      setTimeout(() => {
        this.displayModal = 'block'
      }, 500)
    },

    cancelEdit() {
      this.$emit('cancelEdit')
    }

  },
  mounted() {
    this.setInputFields();
  },

  watch: {
    order() {
      this.setInputFields();
    },

  }

}
</script>

<style scoped>

</style>
